import { ReactMultiEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';

interface Props {
  label: string;
  emails: string[];
  onChange: (emails: string[]) => void;
  placeholder?: string;
}

export function EmailRecipientsField({
  label,
  emails,
  onChange,
  placeholder = 'Enter email addresses',
}: Props) {
  return (
    <div>
      <span className="dark:text-dark-secondary-text mb-1 block text-sm text-gray-700">
        {label}
      </span>
      <ReactMultiEmail
        placeholder={placeholder}
        emails={emails}
        onChange={onChange}
        className="dark:bg-dark-bg dark:border-dark-border-surface rounded-md border border-gray-300 sm:text-sm"
        getLabel={(email, index, removeEmail) => (
          <div data-tag key={index}>
            <div data-tag-item>{email}</div>
            <span data-tag-handle onClick={() => removeEmail(index)}>
              ×
            </span>
          </div>
        )}
      />
      <style>{`
        .react-multi-email {
          background-color: transparent !important;
          padding: 2px;
          color: inherit !important;
        }
        .react-multi-email > input {
          background-color: transparent !important;
          color: inherit !important;
          margin-top: 2px;
          padding: 4px;
          outline: none !important;
          border: none !important;
          box-shadow: none !important;
        }
        .react-multi-email > input:focus {
          outline: none !important;
          border: none !important;
          box-shadow: none !important;
        }
        .react-multi-email [data-tag] {
          color: #374151;
        }
        .dark .react-multi-email [data-tag] {
          color: #d1d5db;
          background-color: #374151;
          border: 1px solid #4b5563;
        }
        .dark .react-multi-email > input {
          color: #e5e7eb !important;
        }
        .react-multi-email.focused {
          border-color: #3b82f6 !important;
          outline: none;
          box-shadow: 0 0 0 1px #3b82f6;
        }
        .react-multi-email.empty > span[data-placeholder] {
          color: #9ca3af;
        }
      `}</style>
    </div>
  );
}

export default EmailRecipientsField;
